"use strict";

exports.__esModule = true;
exports.permissionCheck = void 0;
const permissionCheck = (permissions, string) => {
  const want = string.split('.');
  let denied = false;
  permissions.sort((a, b) => {
    const aV = a.Value.charAt(0) === '-' ? -1 : 2;
    const bV = b.Value.charAt(0) === '-' ? -1 : 2;
    return aV - bV;
  });
  permissions.sort((a, b) => b.Value.split('.').length - a.Value.split('.').length);

  // [{Value: 'verb.entity.id.*'}], 'verb.entity.id'

  const allow = permissions.some(p => {
    const deny = p.Value.charAt(0) === '-';
    const given = deny ? p.Value.slice(1).split('.') : p.Value.split('.');

    // if(given.length < want.length && given[given.length - 1] !== '*') console.log('Not same length or WILDCARD', given[given.length - 1]);

    if (given.length > want.length || given.length < want.length && given[given.length - 1] !== '*') return false;
    let debug = [];
    const w = given.every((e, index) => {
      if (want[index] === e) debug[index] = `position ${index} matches ${e}`;
      if (want[index] !== e && e !== '*') debug[index] = `position ${index} doesn't match ${e}`;
      if (e === '*') debug[index] = `position ${index} is *`;
      if (typeof want[index] === 'undefined') debug[index] = `position ${index} is undefined`;
      return given[index] === '*' || want[index] === e;
    });

    // if (w) {
    //     console.log(`${string} does match ${p.Value} because ${debug.join(' and ')}`, deny);
    // } else {
    //     console.log(`${string} doesnt match ${p.Value} because ${debug.join(' and ')}`, deny);
    // }

    if (w && deny) denied = true;
    return w;
  });

  // if (allow && !denied) {
  //     console.log(`%c ${string} is allowed`, 'color: green');
  // } else {
  //     console.log(`%c ${string} is not allowed`, 'color: red');
  // }

  return allow && !denied;
};
exports.permissionCheck = permissionCheck;